import { ArrowUpRight } from "lucide-react";
import { PLOTS } from "../../lib/data";

/**
 * Plots — light editorial. Uses drone aerials (no villa close-ups).
 */
export default function Plots({ onEnquire }) {
  return (
    <section
      id="plots"
      data-testid="plots-section"
      className="bg-[#F7F5F0] text-[#1A362D] py-20 md:py-32"
    >
      <div className="max-w-[100rem] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-14 md:mb-20 items-end">
          <h2 className="reveal lg:col-span-7 font-serif-display text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight font-light">
            Your own piece <br />
            <em className="font-normal">of the hills.</em>
          </h2>
          <p className="reveal lg:col-span-5 text-[#3A453B] text-base md:text-lg leading-relaxed max-w-md">
            <strong className="text-[#1A362D] font-medium">The Farmhouse Project</strong> —
            plots of 1 and 2 acres, and up to 5 acres. Private, elevated, and
            entirely yours to shape.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {PLOTS.map((p, idx) => (
            <article
              key={p.id}
              data-testid={`plot-card-${p.id}`}
              className={`reveal flex flex-col ${p.featured ? "lg:-mt-10" : ""}`}
              style={{ transitionDelay: `${idx * 90}ms` }}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-[#EBE7DF] group">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A130F]/70 via-transparent to-transparent" />
                {p.featured && (
                  <span className="absolute top-5 left-5 bg-[#1A362D] text-[#F7F5F0] px-3 py-1 text-[10px] tracking-[0.28em] uppercase font-semibold">
                    Most Popular
                  </span>
                )}
                <div className="absolute bottom-5 left-5 right-5">
                  <p className="font-serif-display text-5xl sm:text-6xl md:text-7xl text-[#F7F5F0] leading-none tracking-tight font-light">
                    {p.size}
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <h3 className="font-serif-display text-2xl md:text-[1.75rem] text-[#1A362D] leading-tight tracking-tight">
                  {p.name}
                </h3>
                <p className="mt-3 text-[#3A453B] leading-relaxed">
                  {p.description}
                </p>

                <button
                  data-testid={`plot-enquire-${p.id}`}
                  onClick={() => onEnquire?.({ name: `${p.size} · ${p.name}` })}
                  className="mt-6 inline-flex items-center gap-2 text-[#1A362D] hover:text-[#987F53] transition-colors group/btn"
                >
                  <span className="text-[11px] tracking-[0.28em] uppercase font-semibold border-b border-[#1A362D]/60 group-hover/btn:border-[#987F53] pb-1">
                    Enquire for Pricing
                  </span>
                  <ArrowUpRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
